import React from 'react';
interface PawVerseLogoProps {
  size?: number;
  className?: string;
}
export function PawVerseLogo({
  size = 36,
  className = ''
}: PawVerseLogoProps) {
  return <img src="https://cdn.magicpatterns.com/uploads/ck2vua4EyLkK5f7oGn13Jx/PawVerse_Logo.png" alt="PawVerse Logo" width={size} height={size} className={`object-cover w-full h-full ${className}`} style={{
    width: size,
    height: size
  }} data-id="element-158" />;
}
export function PawVerseWordmark({
  variant = 'light',
  className = ''
}: {
  variant?: 'light' | 'dark';
  className?: string;
}) {
  return <span className={`font-heading tracking-tight ${variant === 'light' ? 'text-primary-900' : 'text-warm-white'} ${className}`} data-id="element-159">
      Paw
      <span className={variant === 'light' ? 'text-accent-500' : 'text-accent-400'} data-id="element-160">
        Verse
      </span>
    </span>;
}